import { useRef } from 'react';
import { requestSequence } from '@/services/requestSequence';

/**
 * requestSequence held for the life of the component: returns `begin`, which marks a new request
 * as the latest and returns whether it still is. A ref, not state — it is read and written inside
 * the effect that starts the request, and re-rendering on it would start another one.
 */
export function useRequestSequence(): () => () => boolean {
  const sequence = useRef<ReturnType<typeof requestSequence> | null>(null);
  sequence.current ??= requestSequence();
  return sequence.current.begin;
}
